import React, { createContext, useContext, useState } from 'react';

const translations = {
    id: {
        // Nav
        dashboard: 'Dasbor', citizens: 'Data Warga', finance: 'Keuangan',
        meetings: 'Undangan Rapat', guestReport: 'Lapor Tamu', complaints: 'Pengaduan & Forum',
        userMgmt: 'Manajemen Pengguna', settings: 'Pengaturan', logout: 'Keluar',
        // Dashboard
        welcome: 'Selamat datang kembali',
        totalCitizens: 'Total KK Warga', totalUsers: 'Total Pengguna',
        iuranMonth: 'Iuran Bulan Ini', expenses: 'Pengeluaran',
        balance: 'Saldo Kas', pendingGuests: 'Tamu Pending',
        openComplaints: 'Pengaduan Terbuka', upcomingMeetings: 'Pertemuan Mendatang',
        recentMeetings: 'Undangan Terbaru', noMeetings: 'Belum ada undangan rapat',
        quickActions: 'Aksi Cepat', recordPayment: 'Catat Iuran',
        addCitizen: 'Tambah Warga', createMeeting: 'Buat Undangan',
        // Citizens
        citizenData: 'Data Warga', searchPlaceholder: 'Cari nama, No. KK...',
        headOfFamily: 'Kepala Keluarga', kkNumber: 'No. KK', address: 'Alamat',
        membersCount: 'Anggota', status: 'Status', actions: 'Aksi',
        viewCard: 'Kartu', editData: 'Edit', deleteData: 'Hapus',
        addNew: 'Tambah Baru', totalData: 'Total Data',
        active: 'Aktif', moved: 'Pindah', deceased: 'Meninggal',
        // Citizen Form
        familyCard: 'No. Kartu Keluarga', nik: 'NIK', fullAddress: 'Alamat Lengkap',
        phone: 'No. Telepon/WA', email: 'Email', rt: 'RT', rw: 'RW',
        familyMembers: 'Anggota Keluarga', addMember: 'Tambah Anggota',
        memberName: 'Nama', memberNik: 'NIK', relationship: 'Hubungan',
        gender: 'Jenis Kelamin', birthDate: 'Tgl Lahir', occupation: 'Pekerjaan',
        male: 'Laki-laki', female: 'Perempuan',
        // Finance
        financeTitle: 'Keuangan RT', iuranTab: 'Iuran', expensesTab: 'Pengeluaran', reportTab: 'Laporan',
        recordIuran: 'Catat Pembayaran', month: 'Bulan', year: 'Tahun', amount: 'Jumlah (Rp)',
        paid: 'Lunas', unpaid: 'Belum Bayar', pending: 'Menunggu',
        collectedBy: 'Dicatat oleh', paymentDate: 'Tgl Bayar',
        expenseCategory: 'Kategori', expenseDesc: 'Keterangan', addExpense: 'Tambah Pengeluaran',
        approve: 'Setujui', reject: 'Tolak', approved: 'Disetujui', rejected: 'Ditolak',
        reportTitle: 'Laporan Keuangan Bulanan', totalIncome: 'Total Pemasukan',
        totalExpenses: 'Total Pengeluaran', netBalance: 'Saldo Bersih',
        paidHouseholds: 'KK Lunas', unpaidHouseholds: 'KK Belum Bayar',
        // Users
        usersTitle: 'Manajemen Pengguna', addUser: 'Tambah Pengguna',
        name: 'Nama', role: 'Jabatan', lastLogin: 'Login Terakhir',
        deactivate: 'Nonaktifkan', activate: 'Aktifkan',
        password: 'Kata Sandi',
        // Settings
        settingsTitle: 'Pengaturan Sistem', regionalTab: 'Wilayah', assetsTab: 'Aset Digital',
        rtNumber: 'Nomor RT', rwNumber: 'Nomor RW', kelurahan: 'Kelurahan',
        kecamatan: 'Kecamatan', kotaKab: 'Kota / Kabupaten', saveSettings: 'Simpan Pengaturan',
        uploadLogo: 'Logo RT', uploadStamp: 'Stempel Resmi', uploadSigKetua: 'TTD Ketua RT',
        uploadSigSek: 'TTD Sekretaris', clickToUpload: 'Klik untuk upload',
        uploadHint: 'PNG, JPG hingga 5MB',
        // Meetings
        meetingsTitle: 'Undangan Rapat', createInvitation: 'Buat Undangan Baru',
        meetingTitle2: 'Judul Rapat', meetingDate: 'Tanggal', meetingTime: 'Waktu',
        meetingLoc: 'Tempat', meetingDesc: 'Deskripsi', agenda: 'Agenda',
        upcoming: 'Mendatang', completed: 'Selesai', cancelled: 'Dibatalkan',
        markComplete: 'Tandai Selesai', deleteMeeting: 'Hapus',
        // Guest
        guestTitle: 'Wajib Lapor Tamu', submitGuest: 'Lapor Tamu Baru',
        guestName: 'Nama Tamu', guestNik: 'NIK Tamu (opsional)',
        guestAddress: 'Alamat Asal Tamu', hostName: 'Nama Tuan Rumah',
        arrivalDate: 'Tanggal Tiba', departureDate: 'Tanggal Pergi (opsional)',
        purpose: 'Tujuan / Keperluan', submitForm: 'Kirim Laporan',
        // Complaints
        complaintsTitle: 'Pengaduan & Forum', addComplaint: 'Buat Pengaduan',
        complaintTitleField: 'Judul Pengaduan', description: 'Deskripsi',
        category: 'Kategori', submitterName: 'Nama Pelapor', submitterPhone: 'No. HP Pelapor',
        addComment: 'Tambah Komentar', comments: 'Komentar',
        openStatus: 'Terbuka', inProgress: 'Diproses', resolved: 'Terselesaikan',
        // Common
        save: 'Simpan', cancel: 'Batal', close: 'Tutup', delete: 'Hapus',
        edit: 'Edit', add: 'Tambah', search: 'Cari', loading: 'Memuat...',
        noData: 'Tidak ada data', confirm: 'Konfirmasi',
        page: 'Halaman', of: 'dari', prev: 'Sebelumnya', next: 'Berikutnya',
        rupiahFormat: (n) => `Rp ${Number(n).toLocaleString('id-ID')}`,
        months: ['', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
                 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
    },
    en: {
        // Nav
        dashboard: 'Dashboard', citizens: 'Citizens', finance: 'Finance',
        meetings: 'Meeting Invitations', guestReport: 'Guest Report', complaints: 'Complaints & Forum',
        userMgmt: 'User Management', settings: 'Settings', logout: 'Logout',
        // Dashboard
        welcome: 'Welcome back',
        totalCitizens: 'Total Households', totalUsers: 'Total Users',
        iuranMonth: 'Monthly Contributions', expenses: 'Expenses',
        balance: 'Cash Balance', pendingGuests: 'Pending Guests',
        openComplaints: 'Open Complaints', upcomingMeetings: 'Upcoming Meetings',
        recentMeetings: 'Recent Invitations', noMeetings: 'No meeting invitations yet',
        quickActions: 'Quick Actions', recordPayment: 'Record Payment',
        addCitizen: 'Add Citizen', createMeeting: 'Create Invitation',
        // Citizens
        citizenData: 'Citizen Data', searchPlaceholder: 'Search name, Family Card No...',
        headOfFamily: 'Head of Family', kkNumber: 'Family Card No.', address: 'Address',
        membersCount: 'Members', status: 'Status', actions: 'Actions',
        viewCard: 'Card', editData: 'Edit', deleteData: 'Delete',
        addNew: 'Add New', totalData: 'Total Records',
        active: 'Active', moved: 'Moved', deceased: 'Deceased',
        // Citizen Form
        familyCard: 'Family Card No.', nik: 'National ID (NIK)', fullAddress: 'Full Address',
        phone: 'Phone/WhatsApp', email: 'Email', rt: 'RT', rw: 'RW',
        familyMembers: 'Family Members', addMember: 'Add Member',
        memberName: 'Name', memberNik: 'NIK', relationship: 'Relationship',
        gender: 'Gender', birthDate: 'Birth Date', occupation: 'Occupation',
        male: 'Male', female: 'Female',
        // Finance
        financeTitle: 'RT Finance', iuranTab: 'Contributions', expensesTab: 'Expenses', reportTab: 'Report',
        recordIuran: 'Record Payment', month: 'Month', year: 'Year', amount: 'Amount (IDR)',
        paid: 'Paid', unpaid: 'Unpaid', pending: 'Pending',
        collectedBy: 'Recorded by', paymentDate: 'Payment Date',
        expenseCategory: 'Category', expenseDesc: 'Description', addExpense: 'Add Expense',
        approve: 'Approve', reject: 'Reject', approved: 'Approved', rejected: 'Rejected',
        reportTitle: 'Monthly Financial Report', totalIncome: 'Total Income',
        totalExpenses: 'Total Expenses', netBalance: 'Net Balance',
        paidHouseholds: 'Paid Households', unpaidHouseholds: 'Unpaid Households',
        // Users
        usersTitle: 'User Management', addUser: 'Add User',
        name: 'Name', role: 'Role', lastLogin: 'Last Login',
        deactivate: 'Deactivate', activate: 'Activate',
        password: 'Password',
        // Settings
        settingsTitle: 'System Settings', regionalTab: 'Regional', assetsTab: 'Digital Assets',
        rtNumber: 'RT Number', rwNumber: 'RW Number', kelurahan: 'Village (Kelurahan)',
        kecamatan: 'Sub-district (Kecamatan)', kotaKab: 'City / Regency', saveSettings: 'Save Settings',
        uploadLogo: 'RT Logo', uploadStamp: 'Official Stamp', uploadSigKetua: 'RT Head Signature',
        uploadSigSek: 'Secretary Signature', clickToUpload: 'Click to upload',
        uploadHint: 'PNG, JPG up to 5MB',
        // Meetings
        meetingsTitle: 'Meeting Invitations', createInvitation: 'Create New Invitation',
        meetingTitle2: 'Meeting Title', meetingDate: 'Date', meetingTime: 'Time',
        meetingLoc: 'Location', meetingDesc: 'Description', agenda: 'Agenda',
        upcoming: 'Upcoming', completed: 'Completed', cancelled: 'Cancelled',
        markComplete: 'Mark Complete', deleteMeeting: 'Delete',
        // Guest
        guestTitle: 'Guest Reporting', submitGuest: 'Report New Guest',
        guestName: 'Guest Name', guestNik: 'Guest NIK (optional)',
        guestAddress: "Guest's Home Address", hostName: 'Host Name',
        arrivalDate: 'Arrival Date', departureDate: 'Departure Date (optional)',
        purpose: 'Purpose of Visit', submitForm: 'Submit Report',
        // Complaints
        complaintsTitle: 'Complaints & Forum', addComplaint: 'New Complaint',
        complaintTitleField: 'Complaint Title', description: 'Description',
        category: 'Category', submitterName: 'Submitter Name', submitterPhone: 'Submitter Phone',
        addComment: 'Add Comment', comments: 'Comments',
        openStatus: 'Open', inProgress: 'In Progress', resolved: 'Resolved',
        // Common
        save: 'Save', cancel: 'Cancel', close: 'Close', delete: 'Delete',
        edit: 'Edit', add: 'Add', search: 'Search', loading: 'Loading...',
        noData: 'No data available', confirm: 'Confirm',
        page: 'Page', of: 'of', prev: 'Previous', next: 'Next',
        rupiahFormat: (n) => `IDR ${Number(n).toLocaleString('en-US')}`,
        months: ['', 'January', 'February', 'March', 'April', 'May', 'June',
                 'July', 'August', 'September', 'October', 'November', 'December'],
    }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState('id');
    const t = translations[lang];
    const toggleLang = () => setLang(l => l === 'id' ? 'en' : 'id');
    return (
        <LanguageContext.Provider value={{ lang, toggleLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => useContext(LanguageContext);
